import { useCallback, useMemo } from "react";
import me from "models/me";
import { InjectedRouter, RouterState } from "react-router";

export const useCurrentMerchantId = ({
    memberships,
    router,
    shouldUpdateMerchantIdInQuery,
}: {
    memberships: nuorder.merchant.v1.Member[];
    router?: RouterState & InjectedRouter;
    shouldUpdateMerchantIdInQuery?: boolean;
}) => {
    const updateMerchantIdInQuery = useCallback(
        (merchantId: string) =>
            process.nextTick(() =>
                router.replace({
                    pathname: router.location.pathname,
                    query: {
                        ...router.location.query,
                        merchantId,
                    },
                })
            ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    const currentMerchantId = useMemo<string>(() => {
        const queryMerchantId = router?.location?.query?.merchantId;
        const userLastChosenMerchantId = me.getLastMerchantId();

        if (queryMerchantId && memberships?.some(({ merchant_id }) => merchant_id === queryMerchantId)) {
            return queryMerchantId;
        }

        if (
            userLastChosenMerchantId &&
            memberships?.some(({ merchant_id }) => merchant_id === userLastChosenMerchantId)
        ) {
            if (shouldUpdateMerchantIdInQuery) {
                updateMerchantIdInQuery(userLastChosenMerchantId);
            }
            return userLastChosenMerchantId;
        }

        if (memberships?.[0]?.merchant_id && shouldUpdateMerchantIdInQuery) {
            updateMerchantIdInQuery(memberships?.[0]?.merchant_id);
        }

        return memberships?.[0]?.merchant_id;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [memberships, router?.location?.query?.merchantId]);

    const setMerchantId = useCallback(
        (merchantId: string) => {
            me.setLastMerchantId(merchantId);
            updateMerchantIdInQuery(merchantId);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [memberships]
    );

    return { currentMerchantId, setMerchantId };
};
